// extracted by mini-css-extract-plugin
export default {"wideMT":"svAkYt","wideMB":"u1cXZp"};